import { render, staticRenderFns } from "./outro.vue?vue&type=template&id=1bc2e8f6&"
import script from "./outro.vue?vue&type=script&lang=js&"
export * from "./outro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports